import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import { LocalStorageService } from 'angular-2-local-storage';
import { GlobalVariable } from './../shared/global';
import { Headers, Http, RequestOptions, ResponseContentType } from '@angular/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators/map';

@Injectable()
export class AgentService {

  private baseApiUrlTest= GlobalVariable.BASE_API_URL;
  private azure_headers : Headers = new Headers();

  // private rest api url variables
  private check_search_url = this.baseApiUrlTest + 'api/admin/loginAs';
  private import_account_url = this.baseApiUrlTest + 'api/admin/import/account';
  private chargeback_function_url = this.baseApiUrlTest + 'api/Authorize/ProcessChargeBackFile';
  private chargeback_validateFile_url = this.baseApiUrlTest + 'api/Authorize/ValidateCSVFileAsync';
  private get_chargeback_ErrorFile = this.baseApiUrlTest + 'api/UsageHistory/chargeback/generateErrorFile';

  constructor(private http: Http) { }

  loginAs(search_key: Object) {
    return this.http
      .post(this.check_search_url, search_key)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  importAccount(data: any) {
    return this.http
      .post(this.import_account_url, data)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  validateChargeBackFile(file: File){
    this.azure_headers.append('Access-Control-Allow-Origin', '*');
    let options = new RequestOptions({ headers : this.azure_headers })

    const formData: FormData = new FormData();
      formData.append('chargebackfile', file, file.name);

    return this.http
      .post(this.chargeback_validateFile_url, formData, options)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  sendChargeBackFile(token:string, file: File){
    this.azure_headers.append('Access-Control-Allow-Origin', '*');

    let options = new RequestOptions({ headers : this.azure_headers })

    const formData: FormData = new FormData();
      formData.append('chargebackfile', file, file.name);
      formData.append('token', token);

    return this.http
      .post(this.chargeback_function_url, formData, options)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  generateChargeBackErrorFile(file: File){
    this.azure_headers.append('Access-Control-Allow-Origin', '*');

    let options = new RequestOptions({ headers : this.azure_headers, responseType: ResponseContentType.Blob })

    const formData: FormData = new FormData();
      formData.append('chargebackfile', file, file.name);

    return this.http
      .post(this.get_chargeback_ErrorFile, formData, options)
      .toPromise()
      .then(res => res)
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/agent/agent.service.ts